import { z } from "zod";

export const discountSchema = z.object({
    id: z.string().nullish(),
    code: z.string(),
    percentage: z.number().nullish(),
    title: z.string(),
    description: z.string(),
});

export const discountResponseSchema = z.object({
    DiscountCodes: z.object({
        docs: z.array(discountSchema),
    }),
});
